module.exports = __webpack_public_path__ + "img/avatar7.25d1538d.png";